/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useRef, useState } from 'react'
import { Button } from '@styles/button.style'
import _ from 'lodash'
import useRootStore from '@store/useRootStore'
import { List } from 'antd'
import { observer } from 'mobx-react'
import dayjs from 'dayjs'
import MessageContentPopup from '@views/Popup/MessageContentPopup'
import BettorGiftContentPopup from '@views/Popup/BettorGiftContentPopup'
import { EMPTY_ICON, GIFT_BTN_TYPE } from '@constants/index'
// img
import { SendbetCouponIco, SendHeartIco, SendMessageIco } from '@shared/Icon/EtcIcon'
// css
import { AdvEmpty } from '@components/AdvEmpty'
import { appScrollTo } from '@utils/utils'
import { BettorListWrap, BettorWrap, BtnStyle, ButtonWrap } from './index.style'
import { BETTOR_FIND_TYPE, FROM_VIEW_TYPE, GlobalStoreKey } from '@v2/constants/common'
import PopupUtils from '@utils/popup-utils'
import { UserPickSpecialMemberMark } from '@views/Home/UserPick/Components/UserPickSpecialMemberMark'
import { ListView } from 'antd-mobile'
import { isIOS, isMobile } from 'react-device-detect'
import { Schema$Bettor } from '@protocol/bettor'
import { useOnMount } from '@utils/reactExt'
import classNames from 'classnames'
import BottomLoading from '@components/BottomLoading'
import { IBettorFindTodayBettingBettorList } from '@interface/global-value'
import AdvImg from '@components/AdvImg'
import { bettingHistoryStore } from '@store/index'
import { FavoriteUsersButton } from '@components/Button/FavoriteUsersButton'

interface BettorFindListProps {
  bettorFindType: BETTOR_FIND_TYPE
  searchNick: string
  onAction: () => void
  onCancel: () => void
}

const FAVORITE_ACTIVE_CLASS = 'icon-btn active ani'

export const BettorFindList: React.FC<BettorFindListProps> = observer((props): React.ReactElement => {
  const { bettorStore, globalStore, authStore, componentStore, userStore } = useRootStore()
  const { bettors, bettorFindHasMore, bettorFindLimit, isLoadingBettors } = bettorStore
  const { isAndroidAppKeyboardVisible } = globalStore
  const { bettorFindType, searchNick, onAction, onCancel } = props

  const [visibleMessageSend, setVisibleMessageSend] = useState(false)
  const [visibleHeartSend, setVisibleHeartSend] = useState(false)
  const favoriteAlarmPendingRef = useRef(new Set<string>())
  const favoriteAlarmProcessedRef = useRef(new Set<string>())
  const [customProfile, setCustomProfile] = useState(false)
  const [nick, setNick] = useState('')
  const [profile, setProfile] = useState('')
  const [receiveId, setReceiveId] = useState('')

  const dataSource = new ListView.DataSource({
    rowHasChanged: (row1, row2) => row1 !== row2,
  })

  const isTicketSendable = userStore.checkTicketSendable()
  const isHeartSendable = userStore.checkHeartSendable()

  let showBetMoney = false
  const todayBettingBettorValue = globalStore.findGlobalSetting(GlobalStoreKey.BETTOR_FIND_TODAY_BETTING_BETTOR_OPTIONS)
  if (todayBettingBettorValue) {
    const options: IBettorFindTodayBettingBettorList = JSON.parse(todayBettingBettorValue.value)
    showBetMoney = _.includes(options.showBetMoneyNickList, authStore.userInfo.nick)
  }

  const action = 'send'
  useOnMount(() => {
    if (isMobile) {
      setTimeout(() => {
        appScrollTo(1)
      }, 0)
    }
  })

  const onCommonSendComponent = (
    inputNick: string, inputCustomProfile: boolean, inputProfile: string,
  ): void => {
    setNick(inputNick)
    setCustomProfile(inputCustomProfile)
    setProfile(inputProfile)
    setVisibleHeartSend(true)
  }

  const onShowHeartSendComponent = (
    inputNick: string, inputCustomProfile: boolean, inputProfile: string,
  ): void => {
    bettorStore.setGiftBtnType(GIFT_BTN_TYPE.HEART)
    onCommonSendComponent(inputNick, inputCustomProfile, inputProfile)
  }

  const onShowTicketSendComponent = (
    inputNick: string, inputCustomProfile: boolean, inputProfile: string,
  ): void => {
    bettorStore.setGiftBtnType(GIFT_BTN_TYPE.TICKET)
    onCommonSendComponent(inputNick, inputCustomProfile, inputProfile)
  }

  const onShowMessageSendComponent = (
    inputNick: string, inputCustomProfile: boolean,
    inputProfile: string, inputReceiveId: string,
  ) => {
    setNick(inputNick)
    setCustomProfile(inputCustomProfile)
    setProfile(inputProfile)
    setReceiveId(inputReceiveId)
    componentStore.setExtraClubId(null)
    bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.BETTOR_FIND)
    bettingHistoryStore.setBettingHistoryInitProps({ onlyMajorClub: false, fromViewType: FROM_VIEW_TYPE.BETTOR_FIND })
    setVisibleMessageSend(true)
  }

  const onClickHeartButton = (item: Schema$Bettor): void => {
    onShowHeartSendComponent(item.nick, item.custom_profile_img, item.profile_img_url)
  }
  const onClickTicketButton = (item: Schema$Bettor): void => {
    onShowTicketSendComponent(item.nick, item.custom_profile_img, item.profile_img_url)
  }
  const onClickSendMessageButton = (item: Schema$Bettor): void => {
    if (onAction) {
      onAction()
    }

    const inputElem: HTMLInputElement = document.querySelector('#better_nick_search_input')
    if (inputElem) {
      inputElem.blur()
    }
    onShowMessageSendComponent(item.nick, item.custom_profile_img, item.profile_img_url, item.id)
  }

  const onClickUserDetailInfoPopup = (item: Schema$Bettor): void => {
    const inputElem: HTMLInputElement = document.querySelector('#better_nick_search_input')
    if (inputElem) {
      inputElem.blur()
    }
    PopupUtils.showUserDetailInfo(item.id)
  }

  // const favoriteUsersButtonClass = `${isFavoriteUsers ? FAVORITE_ACTIVE_CLASS : 'icon-btn'}`

  const onClickFavoriteUsers = async (item: Schema$Bettor) => {
    if (!item.isFavoriteUser) {
      if (favoriteAlarmPendingRef.current.has(item.id)) {
        return
      }
      const shouldSendFavoriteAlarm = !favoriteAlarmProcessedRef.current.has(item.id)
      favoriteAlarmPendingRef.current.add(item.id)
      const added = await userStore.addFavoriteUsers({
        userPromiseIds: [item.id],
        favoriteRegistrationAlarmUserPromiseId: shouldSendFavoriteAlarm ? item.id : undefined,
      })
      favoriteAlarmPendingRef.current.delete(item.id)
      if (added && shouldSendFavoriteAlarm) {
        favoriteAlarmProcessedRef.current.add(item.id)
      }
    } else {
      await userStore.removeFavoriteUsers({ userPromiseIds: [item.id] })
    }
  }

  const renderRow = (item: Schema$Bettor): React.ReactElement => {
    let nickElem: string | React.ReactElement
    const betMoney = item.todayTotalBetMoney || 0
    if (item.nick.indexOf(searchNick) !== -1) {
      const pointedNick = `<span class='point-color--yellow--modal'>${searchNick}</span>`
      nickElem = item.nick.replace(searchNick, pointedNick)
    } else {
      nickElem = item.nick
    }
    const favoriteUsersButtonClass = `${item.isFavoriteUser ? FAVORITE_ACTIVE_CLASS : 'icon-btn'}`
    return (
      <List.Item>
        <BettorWrap>
          <FavoriteUsersButton
            className={favoriteUsersButtonClass}
            onClick={() => {
              onClickFavoriteUsers(item)
            }}
          />
          <Button TP className="user-profile-btn" onClick={() => onClickUserDetailInfoPopup(item)}>
            <div className="profile-img-wrap lhn25">
              {item.custom_profile_img ?
                (<AdvImg src={item.profile_img_url} srcMode={'small'} alt="사진첩 프로필" className="profile-img custom-img"/>)
                :
                (<AdvImg src={item.profile_img_url} srcMode={'small'} alt="스킨 프로필" className="profile-img"/>)
              }
            </div>
            <UserPickSpecialMemberMark
              showSMark={item.sMemberMark}
              isSpecialMember={!_.isNil(item.sMember)}
              userTitleId={item.userTitleId}
              userTitleEnabled={item.userTitleEnabled}
              tiny
              lightBorder/>
            {item.isOnline && <span className="online-status"/>}
          </Button>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span className="bettor-name" dangerouslySetInnerHTML={{ __html: `${nickElem}` }}/>
            {bettorFindType === BETTOR_FIND_TYPE.TODAY_BETTOR && showBetMoney && (
              <span className="bettor-bet-money">
                {dayjs(item.lastBetDate).format('M/D HH:mm:ss')} [{Number(betMoney).toLocaleString()}]
              </span>
            )}
          </div>
        </BettorWrap>
        <ButtonWrap>
          {isTicketSendable && (
            <Button TP onClick={() => onClickTicketButton(item)} css={BtnStyle} className="bet-coupon">
              <SendbetCouponIco/>
            </Button>
          )}
          {isHeartSendable && (
            <Button TP onClick={() => onClickHeartButton(item)} css={BtnStyle} className="heart">
              <SendHeartIco/>
            </Button>
          )}
          <Button TP onClick={() => onClickSendMessageButton(item)} css={BtnStyle} className="message">
            <SendMessageIco/>
          </Button>
        </ButtonWrap>
      </List.Item>
    )
  }

  const renderFooter = (): React.ReactElement => {
    let footer: React.ReactElement
    if (isLoadingBettors) {
      footer = <BottomLoading/>
    } else if (_.size(bettors) > 0) {
      footer = <Fragment/>
    } else if (bettorFindType === BETTOR_FIND_TYPE.NEW_MEMBER) {
      footer = <AdvEmpty ico={EMPTY_ICON.BETTOR_FIND_NEW_MEMBER}/>
    } else if (bettorFindType === BETTOR_FIND_TYPE.FIRST_BET) {
      footer = <AdvEmpty ico={EMPTY_ICON.BETTOR_FIND_FIRST_BET}/>
    } else if (bettorFindType === BETTOR_FIND_TYPE.BET_HIT_SUCCESS) {
      footer = <AdvEmpty ico={EMPTY_ICON.BETTOR_FIND_HIT_SUCCESS}/>
    } else if (bettorFindType === BETTOR_FIND_TYPE.TODAY_BETTOR) {
      footer = <AdvEmpty ico={EMPTY_ICON.BETTOR_FIND_TODAY_BETTOR}/>
    } else if (bettorFindType === BETTOR_FIND_TYPE.ALL_BETTOR) {
      footer = <AdvEmpty ico={EMPTY_ICON.BETTOR}/>
    } else if (bettorFindType === BETTOR_FIND_TYPE.CUSTOM_TAB) {
      footer = <AdvEmpty ico={EMPTY_ICON.BETTOR}/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  const endReachedHandler = (): void => {
    if (bettorFindHasMore) {
      bettorStore.fetchBettors(bettorFindType, searchNick).catch(console.error)
    }
  }

  const receive = {
    id: receiveId,
    nick,
    profile,
    title: '',
  }

  const bettorListWrapClass = classNames('bettor-list-wrap', {
    'pc': !isMobile,
    'ios': isIOS,
    'isAndroidAppKeyboardVisible': isAndroidAppKeyboardVisible
  })

  return (
    <Fragment>
      <BettorListWrap id="bettorListWrap" className={bettorListWrapClass}>
        <ListView
          dataSource={dataSource.cloneWithRows(bettors ?? [])}
          renderRow={renderRow}
          scrollRenderAheadDistance={500}
          renderFooter={renderFooter}
          onEndReached={endReachedHandler}
          onEndReachedThreshold={1000}
          initialListSize={bettorFindLimit}
          pageSize={bettorFindLimit}
        />
      </BettorListWrap>
      <BettorGiftContentPopup
        visible={visibleHeartSend}
        setVisible={setVisibleHeartSend}
        nick={nick}
        isCustomProfile={customProfile}
        profile={profile}
        onCancel={onAction}
        onAction={onCancel}
      />
      <MessageContentPopup
        visible={visibleMessageSend}
        setVisible={setVisibleMessageSend}
        receive={receive}
        action={action}
        useRequestWaitTimer
        fromViewType={FROM_VIEW_TYPE.BETTOR_FIND}
        onAction={onAction}
        onCancel={onCancel}
      />
    </Fragment>
  )
})
